import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { storageService } from 'infrastructure/services/StorageService';

export const useConfirmEmail = (): any => {
  const {
    data,
    error,
    send: confirmEmail,
  } = useRequest({
    url: '/api/v1/auth/email/confirm',
    method: ApiMethodsEnum.Post,
    sendOnStart: false,
    body: {},
  });

  const send = async (body: { hash: string }) => {
    const accessToken = await storageService.getItem('accessToken');
    const refreshToken = await storageService.getItem('refreshToken');
    if (accessToken || refreshToken) return;
    if (body.hash) {
      confirmEmail({ ...body });
    }
  };

  if (!error && data?.token && data?.refreshToken) {
    storageService.setItem('accessToken', data?.token);
    storageService.setItem('refreshToken', data?.refreshToken);
  }

  return { send };
};
